import type { VoidFunctionComponent } from 'react';

import { useOrganizationPackageLabels } from '../../../hooks/api/packageLabels';
import { selectOptionFactory } from '../../../utils';
import Select from '../../generic/Select/Select';

export type Props = {
  /**
   * The initial filter values.
   */
  initialValues: string[];
  /**
   * Callback function to handle changes to the filter.
   */
  onFilterChange: (values: string[]) => void;
};

/**
 * This component renders a multi-select dropdown menu for filtering snippets by package labels.
 */
const PackageLabelsFilter: VoidFunctionComponent<Props> = ({ initialValues, onFilterChange }) => {
  // Load org package labels with the useOrganizationPackageLabels hook.
  const { data: labelsResponse, isLoading: areLabelsLoading } = useOrganizationPackageLabels();
  const labels = labelsResponse?.packageLabels ?? [];

  // Convert the available and selected labels to SelectOptions.
  const availableLabels = labels.map(
    (label) => selectOptionFactory(label.name),
  );
  const selectedLabels = initialValues.map(
    (label) => selectOptionFactory(label),
  );

  return (
    <Select
      id="snippets-package-labels-filter"
      isMulti
      isClearable
      placeholder={areLabelsLoading ? 'Loading...' : 'Package Labels'}
      options={availableLabels}
      value={selectedLabels}
      onChange={(newValues) => onFilterChange(newValues.map((option) => option.value))}
      isDisabled={labels.length === 0}
    />
  );
};

export default PackageLabelsFilter;
